import { getUrlParam } from '../utils/urlParams'

// const showDownloadUI = getUrlParam('showDownloadUI', 'FALSE').toUpperCase() === 'TRUE'
// const orderNumber = getUrlParam('orderNumber', '')
// console.log('showDownloadUI from URL:', showDownloadUI, 'URL param:', getUrlParam('showDownloadUI', 'FALSE'))
// console.log('orderNumber from URL:', orderNumber)

const state = {
  showDownloadUI: getUrlParam('showDownloadUI', 'FALSE').toUpperCase() === 'TRUE',
  orderNumber: getUrlParam('orderNumber', '')
}

const getters = {
  getShowDownloadUI: state => state.showDownloadUI,
  getOrderNumber: state => state.orderNumber
}

const mutations = {
  setShowDownloadUI(state, value) {
    state.showDownloadUI = value
  },
  setOrderNumber(state, value) {
    state.orderNumber = value
  }
}

const actions = {
  initializeUIFromURL({ commit }) {
    const showDownloadUI = getUrlParam('showDownloadUI', 'FALSE').toUpperCase() === 'TRUE'
    const orderNumber = getUrlParam('orderNumber', '')
    commit('setShowDownloadUI', showDownloadUI)
    commit('setOrderNumber', orderNumber)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
